module.exports = __webpack_public_path__ + "static/media/Icon_ContactEmail.55277d73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_ContactEmail.svg
// module id = 2312
// module chunks = 0